// Check if the URL contains the specified string
if (window.location.href.includes("https://nodny.com/pages/mini-nod")) {
  // If it contains the string, remove .active class from the first child
  const logosSliderInner = document.querySelector(".logos__slider-inner");
  const firstChild = logosSliderInner.firstElementChild;
  firstChild.classList.remove("active");
} else {
  // If it does not contain the string, remove .active class from the second child
  const logosSliderInner = document.querySelector(".logos__slider-inner");
  const secondChild = logosSliderInner.children[1];
  secondChild.classList.remove("active");
}
